module.exports = __webpack_public_path__ + "static/img/1_8.3fa9cdeb.jpg";